import { Dispatch, AnyAction } from 'redux';
import { AppState } from '../redux';
import {
    // STORE_ERROR_MESSAGE,
    // STORE_ERROR_BAR,
    // STORE_SUCCESS_MESSAGE,
    // STORE_SUCCESS_BAR,
    STORE_SUCCESS_FILES_UPLOADED_MSG,
    STORE_SUCCESS_FILES_UPLOADED,
    STORE_ERROR_FILES_UPLOADED_MSG,
    STORE_ERROR_FILES_UPLOADED
} from '../reducers/errors';
import axios, { AxiosResponse, AxiosError } from 'axios';
import { STORE_USER_ACCOUNTS, STORE_USER_ACCOUNTS_PUSERNAME, STORE_USER_ACCOUNTS_NICKNAME, STORE_USER_ACCOUNTS_EMAIL, STORE_USER_ACCOUNTS_MOBILE, UserAccountData } from 'src/reducers/userAccount';

export const resetPass = (username: string, dispatch: Dispatch<AppState>, getState: () => AppState) => {
    axios({
        method: 'get',
        url: `${getState().environment.API_URL}sendResetLink?userName=${username}`,
    }).then(async function (response: AxiosResponse) {
        // // ==> console.error(response);
        // // ==> console.error(response.data.ID);
        const successFileUploadOpen = true;
        const successfilemsg = `We'll send you an email with a password link`;
        dispatch({ type: STORE_SUCCESS_FILES_UPLOADED_MSG, successfilemsg } as AnyAction);
        dispatch({ type: STORE_SUCCESS_FILES_UPLOADED, successFileUploadOpen } as AnyAction);

    }).catch(error => {
        // ==> console.error(error);
        const errorFileUploadedOpen = true;
        const errorfilemsg = error.response.data.msg;
        dispatch({ type: STORE_ERROR_FILES_UPLOADED_MSG, errorfilemsg } as AnyAction);
        dispatch({ type: STORE_ERROR_FILES_UPLOADED, errorFileUploadedOpen } as AnyAction);
    });
};

export const resetPassTo = (username: string) => {
    return async (dispatch: Dispatch<AppState>, getState: () => AppState) => {
        resetPass(username, dispatch, getState);
    };
};

export const getUserAccountData = async (dispatch: Dispatch<AppState>, getState: () => AppState) => {

    const sessionid = getState().user.userDetails.s || '';

    axios({
        method: 'post',
        url: `${getState().environment.API_URL}getUserAccounts?userId=${getState().user.userDetails.labCode}`,
        headers: {
            sessionid: sessionid || ''
        },
    }).then(function (response: AxiosResponse) {
        const userAccountdata = response.data;
        dispatch({ type: STORE_USER_ACCOUNTS, userAccountdata } as AnyAction);

    }).catch(function (error: AxiosError) {
        // ==> console.error(error);
        // const errorBar = true;
        // const errorMessage = error.message;
        // dispatch({ type: STORE_ERROR_MESSAGE, errorMessage } as AnyAction);
        // dispatch({ type: STORE_ERROR_BAR, errorBar } as AnyAction);

    });

    const addpusername = '';
    const addnickname = '';
    const addemail = '';
    const addmobile = '';
    dispatch({ type: STORE_USER_ACCOUNTS_PUSERNAME, addpusername } as AnyAction);
    dispatch({ type: STORE_USER_ACCOUNTS_NICKNAME, addnickname } as AnyAction);
    dispatch({ type: STORE_USER_ACCOUNTS_EMAIL, addemail } as AnyAction);
    dispatch({ type: STORE_USER_ACCOUNTS_MOBILE, addmobile } as AnyAction);
};

export const validateEmail = (email: string) => {
    const re = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
    return re.test(String(email).toLowerCase());
};

export const addAccount = () => {
    return async (dispatch: Dispatch<AppState>, getState: () => AppState) => {
        const newUser = {
            pusername: getState().userAccountData.addpusername,
            customer: getState().user.userDetails.labCode,
            nickname: getState().userAccountData.addnickname,
            usertype: 'CUSTOMER',
            reportingto: getState().user.userDetails.labCode,
            email: getState().userAccountData.addemail,
            mobile: getState().userAccountData.addmobile
        };

        if (newUser.pusername === '') {
            const errorFileUploadedOpen = true;
            const errorfilemsg = `User ID should not be blank.`;
            dispatch({ type: STORE_ERROR_FILES_UPLOADED_MSG, errorfilemsg } as AnyAction);
            dispatch({ type: STORE_ERROR_FILES_UPLOADED, errorFileUploadedOpen } as AnyAction);
            return;
        } else {
            const errorFileUploadedOpen = false;
            dispatch({ type: STORE_ERROR_FILES_UPLOADED, errorFileUploadedOpen } as AnyAction);
        }

        if (newUser.pusername.includes(' ')) {
            const errorFileUploadedOpen = true;
            const errorfilemsg = `User ID should not contain spaces.`;
            dispatch({ type: STORE_ERROR_FILES_UPLOADED_MSG, errorfilemsg } as AnyAction);
            dispatch({ type: STORE_ERROR_FILES_UPLOADED, errorFileUploadedOpen } as AnyAction);
            return;
        } else {
            const errorFileUploadedOpen = false;
            dispatch({ type: STORE_ERROR_FILES_UPLOADED, errorFileUploadedOpen } as AnyAction);
        }

        if (newUser.nickname === '') {
            const errorFileUploadedOpen = true;
            const errorfilemsg = `Username should not be blank.`;
            dispatch({ type: STORE_ERROR_FILES_UPLOADED_MSG, errorfilemsg } as AnyAction);
            dispatch({ type: STORE_ERROR_FILES_UPLOADED, errorFileUploadedOpen } as AnyAction);
            return;
        } else {
            const errorFileUploadedOpen = false;
            dispatch({ type: STORE_ERROR_FILES_UPLOADED, errorFileUploadedOpen } as AnyAction);
        }

        if (newUser.email === '') {
            const errorFileUploadedOpen = true;
            const errorfilemsg = `Email should not be blank.`;
            dispatch({ type: STORE_ERROR_FILES_UPLOADED_MSG, errorfilemsg } as AnyAction);
            dispatch({ type: STORE_ERROR_FILES_UPLOADED, errorFileUploadedOpen } as AnyAction);
            return;
        } else {
            const errorFileUploadedOpen = false;
            dispatch({ type: STORE_ERROR_FILES_UPLOADED, errorFileUploadedOpen } as AnyAction);
        }

        if (!validateEmail(newUser.email)) {
            const errorFileUploadedOpen = true;
            const errorfilemsg = `Provide a valid E-mail address`;
            dispatch({ type: STORE_ERROR_FILES_UPLOADED_MSG, errorfilemsg } as AnyAction);
            dispatch({ type: STORE_ERROR_FILES_UPLOADED, errorFileUploadedOpen } as AnyAction);
            return;
        } else {
            const errorFileUploadedOpen = false;
            dispatch({ type: STORE_ERROR_FILES_UPLOADED, errorFileUploadedOpen } as AnyAction);
        }

        const sessionid = getState().user.userDetails.s || '';
        const userAccountdata: UserAccountData[] = getState().userAccountData.userAccountdata;
        const add = {
            rowno: `${userAccountdata.length + 1}`,
            pusername: getState().userAccountData.addpusername,
            nickname: getState().userAccountData.addnickname,
            email: getState().userAccountData.addemail,
            mobile: getState().userAccountData.addmobile
        };
        await axios({
            method: 'post',
            url: `${getState().environment.API_URL}addNewUserAccount`,
            data: newUser,
            headers: {
                sessionid: sessionid || ''
            },
        }).then(function (response: AxiosResponse) {
            const username = getState().userAccountData.addpusername;
            setTimeout(() => resetPass(username, dispatch, getState), 4000);
            
            userAccountdata.push(add);
            dispatch({ type: STORE_USER_ACCOUNTS, userAccountdata } as AnyAction);

            const successFileUploadOpen = true;
            const successfilemsg = `New User has been Added Successfully`;
            dispatch({ type: STORE_SUCCESS_FILES_UPLOADED_MSG, successfilemsg } as AnyAction);
            dispatch({ type: STORE_SUCCESS_FILES_UPLOADED, successFileUploadOpen } as AnyAction);

            const addpusername = '';
            const addnickname = '';
            const addemail = '';
            const addmobile = '';
            dispatch({ type: STORE_USER_ACCOUNTS_PUSERNAME, addpusername } as AnyAction);
            dispatch({ type: STORE_USER_ACCOUNTS_NICKNAME, addnickname } as AnyAction);
            dispatch({ type: STORE_USER_ACCOUNTS_EMAIL, addemail } as AnyAction);
            dispatch({ type: STORE_USER_ACCOUNTS_MOBILE, addmobile } as AnyAction);

        }).catch(error => {

            // ==> console.error(`user account ::: ${JSON.stringify(error.response)}`);
            const errorFileUploadedOpen = true;
            const errorfilemsg = error.response.data.msg;
            dispatch({ type: STORE_ERROR_FILES_UPLOADED_MSG, errorfilemsg } as AnyAction);
            dispatch({ type: STORE_ERROR_FILES_UPLOADED, errorFileUploadedOpen } as AnyAction);

            const addpusername = '';
            const addnickname = '';
            const addemail = '';
            const addmobile = '';
            dispatch({ type: STORE_USER_ACCOUNTS_PUSERNAME, addpusername } as AnyAction);
            dispatch({ type: STORE_USER_ACCOUNTS_NICKNAME, addnickname } as AnyAction);
            dispatch({ type: STORE_USER_ACCOUNTS_EMAIL, addemail } as AnyAction);
            dispatch({ type: STORE_USER_ACCOUNTS_MOBILE, addmobile } as AnyAction);
        });
        return true;
    };
};

export const editAccount = () => {
    return async (dispatch: Dispatch<AppState>, getState: () => AppState) => {
        const editUser = {
            pusername: getState().userAccountData.addpusername,
            nickname: getState().userAccountData.addnickname,
            email: getState().userAccountData.addemail,
            mobile: getState().userAccountData.addmobile
        };

        if (editUser.pusername === '') {
            const errorFileUploadedOpen = true;
            const errorfilemsg = `User ID should not be blank.`;
            dispatch({ type: STORE_ERROR_FILES_UPLOADED_MSG, errorfilemsg } as AnyAction);
            dispatch({ type: STORE_ERROR_FILES_UPLOADED, errorFileUploadedOpen } as AnyAction);
            return;
        } else {
            const errorFileUploadedOpen = false;
            dispatch({ type: STORE_ERROR_FILES_UPLOADED, errorFileUploadedOpen } as AnyAction);
        }

        if (editUser.nickname === '') {
            const errorFileUploadedOpen = true;
            const errorfilemsg = `Username should not be blank.`;
            dispatch({ type: STORE_ERROR_FILES_UPLOADED_MSG, errorfilemsg } as AnyAction);
            dispatch({ type: STORE_ERROR_FILES_UPLOADED, errorFileUploadedOpen } as AnyAction);
            return;
        } else {
            const errorFileUploadedOpen = false;
            dispatch({ type: STORE_ERROR_FILES_UPLOADED, errorFileUploadedOpen } as AnyAction);
        }

        if (editUser.email === '') {
            const errorFileUploadedOpen = true;
            const errorfilemsg = `Email should not be blank.`;
            dispatch({ type: STORE_ERROR_FILES_UPLOADED_MSG, errorfilemsg } as AnyAction);
            dispatch({ type: STORE_ERROR_FILES_UPLOADED, errorFileUploadedOpen } as AnyAction);
            return;
        } else {
            const errorFileUploadedOpen = false;
            dispatch({ type: STORE_ERROR_FILES_UPLOADED, errorFileUploadedOpen } as AnyAction);
        }

        if (!validateEmail(editUser.email)) {
            const errorFileUploadedOpen = true;
            const errorfilemsg = `Provide a valid E-mail address`;
            dispatch({ type: STORE_ERROR_FILES_UPLOADED_MSG, errorfilemsg } as AnyAction);
            dispatch({ type: STORE_ERROR_FILES_UPLOADED, errorFileUploadedOpen } as AnyAction);
            return;
        } else {
            const errorFileUploadedOpen = false;
            dispatch({ type: STORE_ERROR_FILES_UPLOADED, errorFileUploadedOpen } as AnyAction);
        }

        const sessionid = getState().user.userDetails.s || '';
        const userAccountdata: UserAccountData[] = getState().userAccountData.userAccountdata;

        await axios({
            method: 'post',
            url: `${getState().environment.API_URL}updateUserAccount`,
            data: editUser,
            headers: {
                sessionid: sessionid || ''
            },
        }).then(function (response: AxiosResponse) {

            const userIndex = userAccountdata.map((e) => {
                return e.pusername;
            }).indexOf(getState().userAccountData.addpusername);

            userAccountdata[userIndex].nickname = getState().userAccountData.addnickname;
            userAccountdata[userIndex].email = getState().userAccountData.addemail;
            userAccountdata[userIndex].mobile = getState().userAccountData.addmobile;
            userAccountdata.join();

            dispatch({ type: STORE_USER_ACCOUNTS, userAccountdata } as AnyAction);
            const successFileUploadOpen = true;
            const successfilemsg = `Edited Successfully`;
            dispatch({ type: STORE_SUCCESS_FILES_UPLOADED_MSG, successfilemsg } as AnyAction);
            dispatch({ type: STORE_SUCCESS_FILES_UPLOADED, successFileUploadOpen } as AnyAction);
            const editpusername = '';
            const editnickname = '';
            const editemail = '';
            const editmobile = '';
            dispatch({ type: STORE_USER_ACCOUNTS_PUSERNAME, editpusername } as AnyAction);
            dispatch({ type: STORE_USER_ACCOUNTS_NICKNAME, editnickname } as AnyAction);
            dispatch({ type: STORE_USER_ACCOUNTS_EMAIL, editemail } as AnyAction);
            dispatch({ type: STORE_USER_ACCOUNTS_MOBILE, editmobile } as AnyAction);

        }).catch(error => {
            const errorFileUploadedOpen = true;
            const errorfilemsg = error.response.data.msg;
            dispatch({ type: STORE_ERROR_FILES_UPLOADED_MSG, errorfilemsg } as AnyAction);
            dispatch({ type: STORE_ERROR_FILES_UPLOADED, errorFileUploadedOpen } as AnyAction);
            const addpusername = '';
            const addnickname = '';
            const addemail = '';
            const addmobile = '';
            dispatch({ type: STORE_USER_ACCOUNTS_PUSERNAME, addpusername } as AnyAction);
            dispatch({ type: STORE_USER_ACCOUNTS_NICKNAME, addnickname } as AnyAction);
            dispatch({ type: STORE_USER_ACCOUNTS_EMAIL, addemail } as AnyAction);
            dispatch({ type: STORE_USER_ACCOUNTS_MOBILE, addmobile } as AnyAction);
        });
        return true;
    };
};

export const resetUsers = () => {
    return async (dispatch: Dispatch<AppState>, getState: () => AppState) => {

        const addpusername = '';
        const addnickname = '';
        const addemail = '';
        const addmobile = '';
        dispatch({ type: STORE_USER_ACCOUNTS_PUSERNAME, addpusername } as AnyAction);
        dispatch({ type: STORE_USER_ACCOUNTS_NICKNAME, addnickname } as AnyAction);
        dispatch({ type: STORE_USER_ACCOUNTS_EMAIL, addemail } as AnyAction);
        dispatch({ type: STORE_USER_ACCOUNTS_MOBILE, addmobile } as AnyAction);

        return true;
    };
};

export const addPusername = (addpusername: string) => {
    return async (dispatch: Dispatch<AppState>, getState: () => AppState) => {
        dispatch({ type: STORE_USER_ACCOUNTS_PUSERNAME, addpusername } as AnyAction);
        return true;
    };
};
export const addNickname = (addnickname: string) => {
    return async (dispatch: Dispatch<AppState>, getState: () => AppState) => {
        dispatch({ type: STORE_USER_ACCOUNTS_NICKNAME, addnickname } as AnyAction);
        return true;
    };
};
export const addEmailuser = (addemail: string) => {
    return async (dispatch: Dispatch<AppState>, getState: () => AppState) => {
        dispatch({ type: STORE_USER_ACCOUNTS_EMAIL, addemail } as AnyAction);
        return true;
    };
};
export const addMobilename = (addmobile: string) => {
    return async (dispatch: Dispatch<AppState>, getState: () => AppState) => {
        dispatch({ type: STORE_USER_ACCOUNTS_MOBILE, addmobile } as AnyAction);
        return true;
    };
};

export const getUserAcc = (username: string) => {
    return async (dispatch: Dispatch<AppState>, getState: () => AppState) => {
        const userAccountdata: UserAccountData[] = getState().userAccountData.userAccountdata;

        const userIndex = userAccountdata.map((e) => {
            return e.pusername;
        }).indexOf(username);

        const addpusername = userAccountdata[userIndex].pusername;
        const addnickname = userAccountdata[userIndex].nickname;
        const addemail = userAccountdata[userIndex].email;
        const addmobile = userAccountdata[userIndex].mobile;

        dispatch({ type: STORE_USER_ACCOUNTS_PUSERNAME, addpusername } as AnyAction);
        dispatch({ type: STORE_USER_ACCOUNTS_NICKNAME, addnickname } as AnyAction);
        dispatch({ type: STORE_USER_ACCOUNTS_EMAIL, addemail } as AnyAction);
        dispatch({ type: STORE_USER_ACCOUNTS_MOBILE, addmobile } as AnyAction);
        return true;
    };
};



// WEBPACK FOOTER //
// ./src/actions/userAccountAction.ts